import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/led-resistor-calculator',
  component: () => import('../../routes/LedResistorCalculator.svelte'),
  card: {
    id: 'led-resistor-calculator',
    title: 'LED Resistor Calculator',
    description: 'Calculate the correct series resistor for your LED circuit. Enter supply voltage, LED forward voltage, and desired current.',
    icon: 'bolt',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/led-resistor-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'LED Resistor Calculator – Find the Right Resistor for Any LED',
    description: 'Free LED resistor calculator. Enter your supply voltage, LED forward voltage, and desired current to calculate the correct series resistor value with E12 standard values.',
  },
};

export default meta;